
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-edit",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-edit"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"i-edit__eraser",attrs:{"d":"M12.6 3.27l-1 1 2.09 2.09 1-1a.66.66 0 00.09-.94l-1.23-1.24a.7.7 0 00-.95.09z"}}),_c('path',{staticClass:"i-edit__pencil",attrs:{"d":"M10.2 5.67L3.87 12 3 15l2.93-.87 6.34-6.34z"}})])
          )
        }
      }
    